import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "wl_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

// Global axios interceptor: attach admin token to admin routes only.
axios.interceptors.request.use((config) => {
  const url = config.url || "";
  if (url.includes("/api/admin/") && getToken()) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${getToken()}`;
  }
  return config;
});

// 401 handler — clear token and let caller redirect
axios.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && (err?.config?.url || "").includes("/api/admin/")) {
      clearToken();
    }
    return Promise.reject(err);
  }
);

export const authApi = {
  login: async (email, password) => {
    const { data } = await axios.post(`${API}/admin/login`, { email, password });
    setToken(data.access_token);
    return data;
  },
  me: async () => {
    const { data } = await axios.get(`${API}/admin/me`);
    return data;
  },
  changePassword: async (current_password, new_password) => {
    const { data } = await axios.post(`${API}/admin/change-password`, {
      current_password,
      new_password,
    });
    return data;
  },
  logout: () => clearToken(),
};

export default authApi;
